import React, { useEffect, useRef, useState } from 'react';
import { Field, getFormValues } from 'redux-form';
import { Link } from 'react-router-dom';

// config
import config from '../../../../config';

// hocs
import CardFilter from '../../../../hocs/CardFilter';

// validate
import renderField from '../../../../formValidate/renderField';

// Components
import Multiply from '../../../Multiply';
import Tooltip from '../../../Tooltip';

// Styles
import { Row, Col, SeparatorH } from '../../../../styles/align';
import { Wrapper, Label, BtnGroup } from '../../../../styles/forms';
import {
  QuantityBook,
  QuantityBookValues,
  OptionsQuantity,
  Calculator,
  TooltipStyle,
} from './style';
import { connect } from 'react-redux';

const BookQuantity = ({
  data,
  onChangeSubmit,
  onChangeValues,
  activeRequest,
  formValues,
}) => {
  const paginas_preto_branco = useRef();
  const paginas_coloridas = useRef();

  const {
    dependencias_adicionais_cores,
    opcoes_quantidade,
    atributos_selecionados,
    name_quantity,
    is_capa_dura
  } = data;

  const opcaoPreto = dependencias_adicionais_cores.find(
    item => item.cor_impressao.toLowerCase().includes('preto')
  );
  const opcaoColorido = dependencias_adicionais_cores.find(
    item => !item.cor_impressao.toLowerCase().includes('preto')
  );

  const [campoQuantidadeVisivel, setCampoQuantidadeVisivel] = useState('preto_branco');

  const [selectedImpressaoID, setSelectedImpressaoID] = useState(() => {
    if (formValues && formValues.dependencias_adicionais_cores) {
      return formValues.dependencias_adicionais_cores;
    }

    return opcaoPreto
      ? opcaoPreto.pk_dependencia_atributo
      : opcaoColorido
        ? opcaoColorido.pk_dependencia_atributo
        : null;
  });

  useEffect(() => {
    if (formValues && formValues.dependencias_adicionais_cores) {
      const newValue = formValues.dependencias_adicionais_cores;

      if (newValue !== selectedImpressaoID) {
        setSelectedImpressaoID(newValue);
      }
    }
  }, [formValues, selectedImpressaoID]);

  useEffect(() => {
    if (
      formValues &&
      formValues.dependencias_adicionais_cores &&
      opcaoColorido &&
      opcaoColorido.pk_dependencia_atributo
    ) {
      const isColoridas =
        formValues.dependencias_adicionais_cores.toString() ===
        opcaoColorido.pk_dependencia_atributo.toString();

      setCampoQuantidadeVisivel(isColoridas ? 'coloridas' : 'preto_branco');
    }
  }, [formValues, opcaoColorido]);

  const handleChangeValues = (name, value, previousValue = null) => {
    let newValue = value;

    if (name === 'exemplares') {
      const numericValue = parseInt(value, 10);
      if (numericValue >= 5 && numericValue <= 19) {
        newValue = 20;
      }
    }

    onChangeValues(name, newValue);
    onChangeSubmit(
      { target: { name, value: newValue } },
      newValue,
      previousValue,
      name
    );
  };

  const handleQuantidadeChange = (name, value) => {
    if (name === 'paginas_preto_branco' && value > 0) {
      onChangeSubmit(
        { target: { name: 'paginas_coloridas', value: 0 } },
        0,
        null,
        'paginas_coloridas'
      );
    } else if (name === 'paginas_coloridas' && value > 0) {
      onChangeSubmit(
        { target: { name: 'paginas_preto_branco', value: 0 } },
        0,
        null,
        'paginas_preto_branco'
      );
    }
  };

  const isLivreto = data.dados_produto.desc_menu && data.dados_produto.desc_menu.toLowerCase().includes('livreto grampeado');

  return (
    <QuantityBook>
      <TooltipStyle>
        <span>Escolha o tipo da impressão do miolo do seu livro:</span>
        <Tooltip
          dataId={"impressao_miolo_info"}
          text={`
          <strong>
            Como funciona a impressão do miolo?
          </strong>
          <br />
          <p>
            Agora, o cálculo do valor do miolo é feito com base na cobertura de tinta das páginas.
          </p>
          <br />
          <p>
            Você escolhe se quer o miolo <strong>colorido</strong> ou <strong>preto e branco</strong>:
          </p>
          <br />
          <p>
            Se escolher <strong>preto e branco</strong>, o miolo será todo tratado como <strong>P&B</strong>.
          </p>
          <br />
          <p>
            Se escolher <strong>colorido</strong>, consideramos até <strong>15% de cobertura de tinta</strong> por página.
          </p>
          <br />
          <p>
            ⚠️ Caso o seu arquivo tenha uma <strong>cobertura maior que 15%</strong>, o valor será ajustado <strong>automaticamente no carrinho</strong>, e você será avisado antes de finalizar a compra.
          </p>
          <br />
          <p>
            <strong>Importante:</strong> não oferecemos mais a opção "misto" (páginas coloridas e P&B juntas). Se o arquivo tiver qualquer página colorida, <strong>todo o miolo será considerado colorido.</strong>
          </p>
          `}
          size={0.8}
        />
      </TooltipStyle>
      <Col>
        {dependencias_adicionais_cores.slice(0, 2).map((item, i) => {
          return (
            <Row>
              <Wrapper key={i}>
                <Field
                  name="dependencias_adicionais_cores"
                  id={`dependencias_adicionais_cores[${i}]`}
                  type="radio"
                  typefield="radio"
                  component={renderField}
                  value={`${item.pk_dependencia_atributo}`}
                  checked={
                    formValues &&
                    String(formValues.dependencias_adicionais_cores) ===
                    String(item.pk_dependencia_atributo)
                  }
                  onChange={(event, newValue, previousValue, name) => {
                    onChangeSubmit(event, newValue, previousValue, name);

                    const isColorido =
                      String(newValue) ===
                      String(opcaoColorido.pk_dependencia_atributo);

                    const campoParaZerar = isColorido
                      ? 'paginas_preto_branco'
                      : 'paginas_coloridas';

                    // const antigo = formValues && formValues[campoParaZerar]
                    //   ? formValues[campoParaZerar]
                    //   : 0;
                    // onChangeSubmit(
                    //   { target: { name: campoParaZerar, value: 0 } },
                    //   0,
                    //   antigo,
                    //   campoParaZerar
                    // );

                    setCampoQuantidadeVisivel(isColorido ? 'coloridas' : 'preto_branco');
                  }}
                />
                <Label htmlFor={`dependencias_adicionais_cores[${i}]`}>
                  Impressão&nbsp;
                  {item.cor_impressao}
                </Label>
              </Wrapper>
            </Row>
          )
        })}
      </Col>

      {campoQuantidadeVisivel === 'coloridas' && (
        <Col>
          <span>
            <strong>
              Impressões coloridas com mais de 15% de cobertura podem ter alteração no preço!
            </strong>
          </span>
        </Col>
      )}

      {campoQuantidadeVisivel === 'preto_branco' && (
        <Row>
          <span>Quantidade de páginas do miolo</span>
          {isLivreto && (<span>
              <Tooltip
              dataId={'qtd_paginas_livreto'}
              text={`Em casos de livreto grampeado, o número total de páginas deve ser <strong>múltiplo de 4</strong> (ex: 8, 12, 16, 20...).`}
              size={0.8}
            />
            </span>)}
          <Multiply
            step={data.quantidades.multiplicador_paginas}
            ref={paginas_preto_branco}
            name={'paginas_preto_branco'}
            data={data}
            onChangeSubmit={(event, newValue, previousValue, name) => {
              onChangeSubmit(event, newValue, previousValue, name);
              handleQuantidadeChange(name, newValue);
            }}
            identifyMultiply={'paginas'}
            onChangeValues={onChangeValues}
            activeRequest={activeRequest}
            type={'pages'}
          />
        </Row>
      )}

      {campoQuantidadeVisivel === 'coloridas' && (
        <Row>
          <span>Quantidade de páginas do miolo
          {isLivreto && (<span>
              <Tooltip
              dataId={'qtd_paginas_livreto'}
              text={`Em casos de livreto grampeado, o número total de páginas deve ser <strong>múltiplo de 4</strong> (ex: 8, 12, 16, 20...).`}
              size={0.8}
            />
            </span>)}
          </span>
          <Multiply
            step={data.quantidades.multiplicador_paginas}
            ref={paginas_coloridas}
            name={'paginas_coloridas'}
            data={data}
            onChangeSubmit={(event, newValue, previousValue, name) => {
              onChangeSubmit(event, newValue, previousValue, name);
              handleQuantidadeChange(name, newValue);
            }}
            identifyMultiply={'paginas'}
            onChangeValues={onChangeValues}
            activeRequest={activeRequest}
            type={'pages'}
          />
        </Row>
      )}

      <Row>
        <p>Capas e contracapas não entram na contagem das páginas</p>
      </Row>

      <QuantityBookValues>
        <span>
          Total de{' '}
          {data.atributos_selecionados.lados_impressao === config.TYPE_PAGES
            ? 'Folhas'
            : 'Páginas'}{' '}
          <Tooltip
            dataId={'pages_total'}
            text={`A quantidade mínima de ${data.atributos_selecionados.lados_impressao === config.TYPE_PAGES
              ? 'Folhas'
              : 'Páginas'
              } é ${data.quantidades.min_paginas} e a máxima é ${data.quantidades.max_paginas
              }`}
            size={0.8}
          />
        </span>
        <span>
          {atributos_selecionados.paginas_preto_branco ||
            atributos_selecionados.paginas_coloridas ||
            0
          }
        </span>
      </QuantityBookValues>
      <SeparatorH />
      {
        opcoes_quantidade.opcoes.map((item, i) => {
          return (
            <OptionsQuantity key={i}>
              <Col>
                <Wrapper>
                  <Field
                    name={'opcoes_quantidade'}
                    id={`opcoes_quantidade_${i}`}
                    type={'radio'}
                    typefield={'radio'}
                    component={renderField}
                    onChange={(event, newValue, previousValue, name) =>
                      onChangeSubmit(event, newValue, previousValue, name)
                    }
                    value={`${item.fk_sub_tipo_produto}`}
                  />
                  <Label htmlFor={`opcoes_quantidade_${i}`}>
                    {item.texto_dependencia_atributo}
                  </Label>
                </Wrapper>
                <Tooltip
                  dataId={'exemplares_id'}
                  text={`A quantidade mínima de exemplares é ${data.quantidades.min_exemplares} e a máxima é ${data.quantidades.max_exemplares}`}
                  size={0.8}
                />
              </Col>
              <Col>
                {item.fk_sub_tipo_produto === config.TYPE_QUANTITY_COPIES ? (
                  <>
                    <Multiply
                      step={data.quantidades.multiplicador_tiragem}
                      name={'exemplares'}
                      data={data}
                      onChangeSubmit={handleChangeValues}
                      identifyMultiply={'exemplares'}
                      onChangeValues={handleChangeValues}
                      activeRequest={activeRequest}
                    />
                  </>
                ) : (
                  '1 UN'
                )}
              </Col>
            </OptionsQuantity>
          );
        })
      }
      <SeparatorH />

      {
        data.lombada ? (
          <Calculator>
            <BtnGroup>
              <Link to={`/calculo-de-lombada/${atributos_selecionados.tipos_papel_miolo}/${atributos_selecionados.paginas_coloridas + atributos_selecionados.paginas_preto_branco}/${is_capa_dura ? 1 : 0}`} target="_blank" rel="noopener noreferrer">
                Calcular Lombada »
              </Link>
            </BtnGroup>
          </Calculator>
        ) : (
          ''
        )
      }
    </QuantityBook >
  );
};

const mapStateToProps = (state) => {
  const formValues = getFormValues('filterProductsOnChange')(state);
  return { formValues };
};

export default CardFilter(connect(mapStateToProps)(BookQuantity));